import { render, staticRenderFns } from "./FunPointLayout.vue?vue&type=template&id=38fbdd84&scoped=true&"
import script from "./FunPointLayout.vue?vue&type=script&lang=js&"
export * from "./FunPointLayout.vue?vue&type=script&lang=js&"
import style0 from "./FunPointLayout.vue?vue&type=style&index=0&id=38fbdd84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fbdd84",
  null
  
)

export default component.exports